import { render, staticRenderFns } from "./ApgarCell.vue?vue&type=template&id=3289506a&scoped=true"
import script from "./ApgarCell.vue?vue&type=script&lang=js"
export * from "./ApgarCell.vue?vue&type=script&lang=js"
import style0 from "./ApgarCell.vue?vue&type=style&index=0&id=3289506a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3289506a",
  null
  
)

export default component.exports